exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".package[data-v-9a4ed094]{border-color:#d1d5db}.package.package-selected[data-v-9a4ed094]{border-color:#1f2937}.package.sold-out[data-v-9a4ed094]{opacity:.55}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-9a4ed094","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/package-selector.vue
// module id = HCRd
// module chunks = 116